import { DictionaryLink, Language } from "../../rest/models";
import { DictLinkEditForm } from "./DictLinkEditForm";
import { DictLinkListRow } from "./DictLinkListRow";

export function DictLinkLanguageListRow(props: Props)
{
    const l = props.lang;
    const dicts = props.dicts;

    const tableRows = dicts.map(d => <DictLinkListRow key={d.key} lang={l} dict={d}/>);

    return (
    <fieldset className='ernots_TableWrapper'>
        <div>Create new dictionary for <b>{l?.name ?? 'any language'}</b>:</div>
        <DictLinkEditForm lang={l} onDone={() => {}}/>
        <br/>

        <div>Dictionaries for <b>{l?.name ?? 'any language'}</b></div>
        <table className='ernots_ModelTable ernots_DictLinkTable' border={1}>
            <thead>
                <tr>
                    <th>Text</th>
                    <th>URL pattern</th>
                    <th>Edit</th>
                    <th>Delete</th>
                </tr>
            </thead>
            <tbody>
                {tableRows}
            </tbody>
        </table>
    </fieldset>);
}

interface Props
{
    lang?: Language;
    dicts: DictionaryLink[];
}